<template>
    <table cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;" class="q-ma-lg">
        <colgroup width="25"></colgroup>
        <colgroup width="73"></colgroup>
        <colgroup width="197"></colgroup>
        <colgroup width="42"></colgroup>
        <colgroup width="55"></colgroup>
        <colgroup width="84"></colgroup>
        <colgroup width="82"></colgroup>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000" height="14" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>Рахунок-фактура № {{ bill.number }}</font></b></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>{{ bill.created_at }} року</font></b></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 height="33" align="left" valign=top><b><font size=2>Одержувач:</font></b></td>
            <td style="border-top: 1px solid #000000" colspan=4 align="left" valign=middle><font
                    size=2>{{ requisites.name }},
                <br>ЄДРПОУ {{ requisites.tin }}</font></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=top><font
                    size=2><br></font></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000" height="15" align="left" valign=middle><font size=2><br></font>
            </td>
            <td style="border-right: 1px solid #000000" align="left" valign=middle><font size=2><br></font></td>
            <td colspan=4 align="left" valign=middle><font size=2>{{ requisites.address }}</font></td>
            <td style="border-right: 1px solid #000000" align="center" valign=middle><font size=2><br></font></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000" height="15" align="left" valign=middle><font size=2><br></font>
            </td>
            <td style="border-right: 1px solid #000000" align="left" valign=middle><font size=2><br></font></td>
            <td style="border-right: 1px solid #000000" colspan=5 align="left" valign=middle>
                <font size=2>
                    {{ requisites.checking_account }} {{ requisites.bank_name }}
                </font>
            </td>
        </tr>
        <tr v-if="requisites.additional_info">
            <td style="border-left: 1px solid #000000" height="16" align="left"><br></td>
            <td style="border-right: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left" colspan=2>
                <b><font size=2>{{ requisites.additional_info }}</font></b>
            </td>
            <!--      <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left"><br></td>-->
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000"
                align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=top><b><font size=2>Платник:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    <span>
                        {{ receiver }}
                        <br>
                    </span>
                    <span v-if="userRequisites.edrpou">
                        {{ isCompanyTypeBusinessNds ? 'РНОКПП' : 'ЄДРПОУ' }} {{ userRequisites.edrpou }}
                        <br>
                    </span>
                    <span v-if="userRequisites.inn">
                        {{ isNdsPayer ? 'ІПН' : 'РНОКПП'}} {{ userRequisites.inn }}
                        <br>
                    </span>
                    <span v-if="userRequisites.iban">
                        {{ userRequisites.iban }}
                        <br>
                    </span>
                    <span v-if="userRequisites.legal_address">
                        {{ userRequisites.legal_address }}
                        <br>
                    </span>
                    <span v-if="userRequisites.actual_address">
                        {{ userRequisites.actual_address }}
                        <br>
                    </span>
                    <span v-if="userRequisites.full_name">
                        {{
                            userRequisites.user_position
                                ? `${userRequisites.user_position} ${userRequisites.full_name}`
                                : userRequisites.full_name
                        }}
                        <br>
                    </span>
                </font></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=middle><b><font size=2>Сервіс код:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    {{ bill.project.service_code }}
                </font></td>
        </tr>
        <tr>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    height="32" align="center" valign=middle><b><font size=2>№</font></b></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    colspan=2 align="center" valign=middle><b><font size=2>Найменування послуг</font></b></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="center"><b><font size=2>Од.<br>вим.</font></b></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="center" valign=middle><b><font size=2>Кількість</font></b></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="center" valign=middle><b><font size=2>Ціна без ПДВ</font></b></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="center" valign=middle><b><font size=2>Сума без ПДВ</font></b></td>
        </tr>
        <tr>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    colspan=2 align="left" valign=top><font size=2>{{ bill.destination }}</font>
            </td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="left" valign=top><font size=2>{{ bill.service ? bill.service.service.unit : 'шт' }}.</font>
            </td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                    v-if="isVatPayer"
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ vatPaymentAmount.toFixed(2) }}</font></td>
            <td
                    v-else
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ paymentAmount.toFixed(2) }}</font></td>
            <td
                    v-if="isVatPayer"
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ vatPaymentAmount.toFixed(2) }}</font></td>
            <td
                    v-else
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ paymentAmount.toFixed(2) }}</font></td>
        </tr>
        <tr v-if="bill.paid_amount > 0 && bill.paid_amount < bill.amount">
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>2</font></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    colspan=2 align="left" valign=top><font size=2>Оплата, яка вже надійшла</font>
            </td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="left" valign=top><font size=2>шт.</font></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                    size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    height="24" colspan=6 align="right"><b><font size=2>Разом:</font></b></td>
            <td
                    v-if="isVatPayer"
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                    size=2>{{ vatPaymentAmount.toFixed(2) }}</font></td>

            <td
                    v-else
                    style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                    align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                    size=2>{{ paymentAmount.toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>Сума ПДВ:</font></b></td>

            <td v-if="isVatPayer"
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                    size=2>{{ vatAmount.toFixed(2) }}</font>
            </td>
            <td v-else
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                    size=2>Без ПДВ</font>
            </td>
        </tr>
        <tr v-if="isVatPayer">
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>Усього з ПДВ:</font></b></td>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right">
                <font size=2>{{ paymentAmount.toFixed(2) }}</font>
            </td>
        </tr>
        <tr v-if="isOtherService">
            <td colspan="100%" style="text-align: left">
                <br>
                <font size="2">
                    Цей рахунок-фактура сформований на підставі отриманого від Платника замовлення через платформу
                    Хорошоп або
                    іншими засобами зв'язку.
                    Оплачуючи цей рахунок-фактуру Платник підтверджує факт такого замовлення та зобов'язаний прийняти
                    розширення
                    функціоналу комп'ютерної програми (програмної продукції) у вигляді онлайн-сервісу (платформи).
                </font>
            </td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td style="color: red" colspan="6" valign=top><b><font size=2>{{ requisites.custom_data }}</font></b>
            </td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td v-if="isVatPayer"
                align="left" colspan=6 valign=top><b><i><font size=2>
                <br>Всього до сплати: {{ paymentAmount }}
                гривень {{ bill.amount % 100 }} копiйок, в т.ч. ПДВ </font></i></b>
            </td>

            <td v-else
                align="left" colspan=6 valign=top><b><i><font size=2>
                <br>Всього до сплати: {{ paymentAmount }}
                гривень {{ bill.amount % 100 }} копiйок, без ПДВ </font></i></b>
            </td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td height="30" align="left"><br></td>
            <td align="left"><br></td>
            <td colspan=5 align="left" style="position: relative;">
                <font size=2>Рахунок виписав __________________ /{{ requisites.name_in_signature }}/</font>
                <img v-if="requisites.stamp_img_url" :src="requisites.stamp_img_url" alt="" class="stamp">
            </td>
        </tr>
        <td align="left" colspan=6 valign=top><b><i><font size=2>
            <br>УВАГА! В призначенні платежу обов'язково ВКАЗАТИ НОМЕР РАХУНКУ-ФАКТУРИ {{ bill.number }}
        </font></i></b>
        </td>
    </table>
</template>

<script>
import {COMPANY_TYPE_BUSINESS_NDS, COMPANY_TYPE_ENTERPRISE} from "../../../constants/companyTypes";

export default {
  name: 'DataGrid',

  props: {
    bill: {
      type: Object,
      required: true,
    },

    requisites: {
      type: Object,
      required: true,
    },

    userRequisites: {
      type: Object,
      required: true,
    },

    ndsData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    paymentAmount () {
      const amount = (this.bill.paid_amount < this.bill.amount)
                     ? this.bill.amount - this.bill.paid_amount
                     : this.bill.amount

      return amount / 100
    },

    isVatPayer () {
      return this.ndsData.ndsPayer === 1 && new Date(this.bill.true_created_at) > new Date('2020-01-31 23:59:00')
    },

    vatPaymentAmount () {
      return this.paymentAmount / 1.2
    },

    vatAmount () {
      return this.paymentAmount - this.vatPaymentAmount
    },

    receiver () {
      if (!this.userRequisites.company_name && this.bill.status === 'PAID') {
        return null
      }

      return this.userRequisites.company_name
        ? this.userRequisites.company_name
        : this.bill.project.payment_data?.company_name
          ? this.bill.project.payment_data.company_name
          : 'Приватна особа'
    },

    isOtherService () {
      return this.bill.destination.includes('Розширення функціоналу комп\'ютерної програми (програмної продукції)')
    },

    isCompanyTypeBusinessNds () {
      return this.userRequisites.company_type === COMPANY_TYPE_BUSINESS_NDS
    },

    isNdsPayer () {
      return this.userRequisites.company_type === COMPANY_TYPE_ENTERPRISE || this.userRequisites.company_type === COMPANY_TYPE_BUSINESS_NDS
    },
  },
}
</script>

<style scoped>
.stamp {
    position: absolute;
    z-index: -1;
    width: 200px;
    height: auto;
    left: 125px;
    top: -47px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Invoice/ua/DataGrid.vue